import React from "react";
import { Company } from "../../assets/Data";

const ContactUs = () => {
  const company = Company[0];

  // address is stored with <br/> separators in Data.js
  const addressLines = String(company.address)
    .split(/<br\s*\/?>/i)
    .map((line) => line.trim())
    .filter(Boolean);

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 col-sm-12">
          <div className="my-5 mx-4 contact-info">
            <p className="fw-bold m-0">{company.fullName},</p>
            {addressLines.map((line, i) => (
              <p className="fw-bold m-0" key={i}>
                {line}
              </p>
            ))}
          </div>

          <div className="contact mx-4">
            <p className="fw-bold m-0">{company.phone}</p>
            {company.alternateNumber && company.alternateNumber.length > 0 && (
              <p className="fw-bold m-0">
                {company.alternateNumber.join(", ")}
              </p>
            )}
            <p className="fw-bold m-0">{company.email}</p>
            {company.website && (
              <p className="fw-bold m-0">{company.website}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
